import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'
import cn from 'classnames/bind'

import type { Flash as FlashProps, FlashType } from 'modules/core/store/models/app'

import styles from './index.module.scss'

const cx = cn.bind(styles)

function FlashIcon({ type }: { type: FlashType }) {
  if (type === 'correct') {
    return <Icon.Medium icon="check-circle" color="grey000White" />
  }

  return <Icon.Medium icon="cross-circle" color="grey000White" />
}

export default function Flash({ close, type, message }: FlashProps) {
  // Do not render flash when message not present
  if (!message) return null

  return (
    <div role="alert" className={cx('flash', type)}>
      <FlashIcon type={type} />
      <div className={styles.message}>{message}</div>
      {Boolean(close) && (
        <button className={styles.close} onClick={close} type="button">
          <Icon.Small icon="close" color="grey800" />
        </button>
      )}
    </div>
  )
}
